import * as React from "react";

import { cn } from "@/lib/utils";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean;
}

/** A tab in a Spend Centre tab strip; callers set the ARIA role and state that fit the strip. */
export const UnderlineTab = ({ active, className, ...props }: Props) => (
  <button
    type="button"
    className={cn(
      "-mb-px border-b-2 px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      active ? "border-spend-ink text-spend-ink" : "border-transparent text-gray-500 hover:text-spend-ink",
      className,
    )}
    {...props}
  />
);
